import { createTag, editTag, TagUpdateType, useUpdateTags } from '@ukpostbox/client-data';
import { ButtonSubmit, ColourStateSolid, FormWrapperLabel, Modal, useTranslation } from '@ukpostbox/frontend-framework';
import { FieldValues, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect } from 'react';
import { CreateTagModalType } from '../Types/TagTypes';

function CreateTagModal(props: CreateTagModalType) {
	const { t } = useTranslation();
	const updateTags = useUpdateTags();

	const {
		register,
		handleSubmit,
		reset,
		formState: { errors, isValid },
	} = useForm({
		mode: 'onChange',
	});

	const CreateTag = (data: FieldValues) => {
		createTag(data.name).then((r) => {
			if (r.data) {
				updateTags.mutate({
					newData: r.data,
					tagIds: [r.data.id],
					updateType: TagUpdateType.CREATE,
				});
			}
		});

		props.actionedCallback();
	};

	const EditTag = (data: FieldValues, id: number) => {
		editTag(data.name, id).then((r) => {
			if (r.data) {
				updateTags.mutate({
					newData: data.name,
					tagIds: [id],
					updateType: TagUpdateType.EDIT,
				});
			}
		});

		props.actionedCallback();
	};

	useEffect(() => {
		reset();
	}, [props.isOpen]);

	return (
		<Modal
			title={props.existingData ? t('settings.tags.actions.edit') : t('settings.tags.actions.new')}
			isOpen={props.isOpen}
			closeCallback={() => props.closeCallback()}
		>
			<form
				onSubmit={handleSubmit((data: any) =>
					props.existingData ? EditTag(data, props.existingData.id) : CreateTag(data),
				)}
			>
				<fieldset className='flex-column flex-gap-md'>
					<FormWrapperLabel
						label={t('name')}
						invalid={errors.name && errors.name?.message !== ''}
						validationMessage={errors.name?.message as string}
					>
						<input
							type='text'
							defaultValue={props.existingData?.name}
							aria-invalid={errors.name ? 'true' : 'false'}
							{...register('name', {
								required: 'This is a required field',
								minLength: { value: 2, message: 'Too short' },
							})}
						/>
					</FormWrapperLabel>

					<ButtonSubmit
						title={t('actions.save')}
						fullWidth
						colour={ColourStateSolid.Primary}
						disabled={!isValid}
					/>
				</fieldset>
			</form>
		</Modal>
	);
}

export default CreateTagModal;
